import copy from '../../demo/fixtures/w5/copy.json'
import { Card, CardHead, Icon } from '../../ui'
import { BenchPosition } from './BenchPosition'
import { BenchSignals } from './BenchSignals'
import { BenchTrend } from './BenchTrend'
import styles from './AutomationPage.module.css'

export function BenchmarkCard() {
  return (
    <Card className={`${styles.aiCard} ${styles.section} ${styles.benchmarkCard}`} data-scope="benchmark-card" lang="zh-CN">
      <CardHead
        title={copy.sections.benchmark}
        subtitle={copy.sections.benchmarkHint}
        action={
          <span className={`${styles.statusChip} ${styles.aiChip}`}>
            <Icon name="sparkle" size={12} strokeWidth={2} />
            AI 校准
          </span>
        }
      />
      <BenchPosition />
      <BenchTrend />
      <BenchSignals />
    </Card>
  )
}
